import React from 'react'
import { Navbar } from './components/Navbar'
import { Footer } from './components/Footer'

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative min-h-screen bg-[#0a0a0f]">
      <Navbar />
      <main>{children}</main>
      <Footer />
    </div>
  )
}
